import React from 'react';

import { SHIFT } from 'models/baselines';
import { getBaselineTotal } from '../Baselines.helpers';
import { BaselineItemTotalProps } from '../Baselines.types';
import styles from './BaselineItemTotals.module.scss';

export const BaselineItemTotals = ({
  period,
  total
}: BaselineItemTotalProps) => {
  let day;
  let night;
  if (period) {
    const { baselines } = period;
    day = getBaselineTotal(baselines, SHIFT.DAY);
    night = getBaselineTotal(baselines, SHIFT.NIGHT);
  }
  if (total) {
    day = total.day;
    night = total.night;
  }
  return (
    <>
      <div>
        <h1 data-testid="totalDay" className={styles.number}>
          {day}
        </h1>
      </div>
      <div>
        <h1 data-testid="totalNight" className={styles.number}>
          {night}
        </h1>
      </div>
      <div className={styles.baselineItemCompanies}>
        <h1 className={styles.total}>Total</h1>
      </div>
    </>
  );
};
